import { computed, type Ref } from "vue"
import { useRoute } from "vue-router"
import { ProjectType } from "@/graphql"
import { Mode, isTableType } from "@/model/RootStore"
import type { Project } from "@/model/DataModel"
import { firstQueryValue, Route } from "@/utils/routing"

type NavigationContextOptions = {
	currentProject?: Ref<Project | null | undefined>
}

export function useNavigationContext(options: NavigationContextOptions = {}) {
	const route = useRoute()

	const tableType = computed(() => {
		const value = firstQueryValue(route.query.table)
		return isTableType(value) ? value : null
	})

	const mode = computed(() => (tableType.value ? Mode.Table : Mode.Map))
	const isMapMode = computed(() => mode.value === Mode.Map)
	const isTableMode = computed(() => mode.value === Mode.Table)

	// TODO use this as the consistent app-wide navigation section source of truth.
	// Current usage is intentionally scoped to the new View/SearchContext path.
	const isHuntingSection = computed(
		() =>
			route.name === Route.Hunting ||
			firstQueryValue(route.query.project) != null ||
			(route.name === Route.Home && options.currentProject?.value?.type === ProjectType.Cca)
	)

	return {
		mode,
		tableType,
		isMapMode,
		isTableMode,
		isHuntingSection,
	}
}
